<span>Select Period</span>
<div class="dropdown-ind">
  <a>
    <select [value]="undefined" (change)="onSelectChange($event.target.value)">
      <option *ngFor="let option of options" [value]="option.key" [selected]="option.key === null">
        {{ option.value }}
      </option>
    </select>
  </a>
</div>
